import { Card, CardContent } from "@getgreenline/blaze-ui";
import { cn } from "@getgreenline/blaze-ui";

type SelectableCardProps = React.ComponentProps<typeof Card> & {
  interactive?: boolean;
  selected?: boolean;
  dimmed?: boolean;
  contentClassName?: string;
  onSelect?: () => void;
};

export function SelectableCard({
  interactive = false,
  selected = false,
  dimmed = false,
  className,
  contentClassName,
  onSelect,
  onKeyDown,
  children,
  ...props
}: SelectableCardProps) {
  return (
    <Card
      role={interactive ? "button" : props.role}
      tabIndex={interactive ? 0 : props.tabIndex}
      onClick={() => {
        if (interactive) {
          onSelect?.();
        }
      }}
      onKeyDown={(event) => {
        if (interactive && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          onSelect?.();
        }

        onKeyDown?.(event);
      }}
      className={cn(
        "tw:px-4 tw:py-3 tw:shadow-none",
        interactive && "tw:cursor-pointer",
        selected && "tw:border-sky-500 tw:bg-sky-50/50 tw:dark:bg-black",
        dimmed && "tw:opacity-45",
        className,
      )}
      {...props}
    >
      <CardContent className={cn("tw:p-0", contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
